import {
    configureStore,
    getDefaultMiddleware,
    createSlice,

} from "@reduxjs/toolkit";

import anonymizerReducer from "./anonymizerSlice";

import {
    getTrainingDataList,
    saveTrainingData,
    getTrainingDataFile,
    testModel,
    createModel,
    getModels,
    callJobApi, getTags, getEntities, getConfig, saveConfig,
    getJobs, createJob, updateJob, deleteJob, startJobRun
} from "./asyncActions";

import {migrateConfig} from "../configMigration";


const middleware = [
    ...getDefaultMiddleware(),
    /*YOUR CUSTOM MIDDLEWARES HERE*/
];



const requestState = {
    tags:[],
    activeTag:"TAG-0",
    models:[],
    loading:false,
    error:"",
    files:[],
    trainingData:[],
    testResult:"",
    analysis:[],
    jobStatus:{},
    all_entities:[],
    config:undefined,
    unsavedConfig:false,
    success:false,
    jobs:[],
    jobsLoading:false,
    jobsError:"",
    dynamicTagging:null,
    privacyFilter:null,
    entities:{}
};

function parseConfigFields(state, configString) {
    try {
        const raw = JSON.parse(configString);
        const migrated = migrateConfig(raw);
        state.dynamicTagging = migrated.dynamicTagging || null;
        state.privacyFilter = migrated.privacyFilter || null;
        state.entities = migrated.entities || {};
    } catch (e) {
        // keep existing values on parse error
    }
}



const requestSlice = createSlice({
    name: "request",
    initialState: requestState,
    reducers: {

        resetState:(state)=> {
            return state = {
                tags:[],

                models:[],
                loading:false,
                error:"",
                activeTag:"TAG-0",
                files:[],
                trainingData:[],
                testResult:"",
                analysis:[],
                jobStatus:{},
                all_entities:[],
                config:undefined,
                unsavedConfig:false,
                success:false,
                jobs:[],
                jobsLoading:false,
                jobsError:""

            };

        },


        setTags:(state,action)=> {

            if (Array.isArray(action.payload)){
                state.tags = action.payload;
            }
            return state;

        },
        setActiveTag:(state,action)=> {

            if (action.payload){
                state.activeTag = action.payload;
            }
            return state;

        },
        changeConfig:(state,action)=> {

            if (action.payload){
                state.config = action.payload;
                state.unsavedConfig = true;
                parseConfigFields(state, action.payload);
            }
            return state;

        },
        resetSuccess:(state,action)=>{
            state.success=false
        },
        clearTestResult:(state)=>{
            state.testResult="";
            state.analysis=[];
        },
        addEntity:(state,action)=>{
            const {entityType, labels} = action.payload;
            state.entities[entityType] = {labels: labels || []};
        },
        removeEntity:(state,action)=>{
            const entityType = action.payload;
            delete state.entities[entityType];
        },
        updateEntityLabels:(state,action)=>{
            const {entityType, labels} = action.payload;
            if (state.entities[entityType]) {
                state.entities[entityType].labels = labels;
            } else {
                state.entities[entityType] = {labels};
            }
        }




    },
    extraReducers:{
        [saveTrainingData.pending]: state => {
            state.loading = true;
        },
        [saveTrainingData.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [saveTrainingData.fulfilled]: (state, action) => {
            state.loading = false;


        },
        [callJobApi.pending]: state => {
            state.loading = true;
        },
        [callJobApi.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [callJobApi.fulfilled]: (state, action) => {
            state.loading = false;
            state.jobStatus=action.payload


        },
        [getTags.pending]: state => {
            state.loading = true;
        },
        [getTags.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [getTags.fulfilled]: (state, action) => {
            state.loading = false;
            console.log(action)
            state.all_entities=action.payload


        },
        [getTrainingDataList.pending]: state => {
            state.loading = true;
        },
        [getTrainingDataList.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [getTrainingDataList.fulfilled]: (state, action) => {
            state.loading = false;
            state.files=action.payload

        },
        [getTrainingDataFile.pending]: state => {
            state.loading = true;
        },
        [getTrainingDataFile.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [getTrainingDataFile.fulfilled]: (state, action) => {
            state.loading = false;
            state.trainingData=action.payload


        },
        [testModel.pending]: state => {
            state.loading = true;
        },
        [testModel.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [testModel.fulfilled]: (state, action) => {
            state.loading = false;
            state.testResult=action.payload.anonymized
            state.analysis=action.payload.analysis
            state.testDurationMs=action.payload.durationMs


        },
        [createModel.pending]: state => {
            state.loading = true;
        },
        [createModel.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [createModel.fulfilled]: (state, action) => {
            state.loading = false;
            state.models=action.payload


        },[getModels.pending]: state => {
            state.loading = true;
        },
        [getModels.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [getModels.fulfilled]: (state, action) => {
            state.loading = false;
            state.models=action.payload


        },
        [getEntities.pending]: state => {
            state.loading = true;
        },
        [getEntities.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [getEntities.fulfilled]: (state, action) => {
            state.loading = false;
            state.tags=action.payload


        },
        [getConfig.pending]: state => {
            state.loading = true;
        },
        [getConfig.rejected]: (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        },
        [getConfig.fulfilled]: (state, action) => {
            state.loading = false;
            state.config= JSON.stringify(JSON.parse(action.payload), null, 2);
            state.unsavedConfig=false;
            state.success=false;
            parseConfigFields(state, action.payload);
        },
        [saveConfig.pending]: state => {
            state.loading = true;
        },
        [saveConfig.rejected]: (state, action) => {
            state.loading = false;
            state.success=false
            state.error = action.error.stack;
            console.log(action.error)
        },
        [saveConfig.fulfilled]: (state, action) => {
            state.loading = false;
            state.unsavedConfig=false;
            state.config= JSON.stringify(JSON.parse(action.payload), null, 2);
            state.error = undefined;
            state.success=true;
            parseConfigFields(state, action.payload);
        },
        // Jobs reducers
        [getJobs.pending]: state => {
            state.jobsLoading = true;
            state.jobsError = "";
        },
        [getJobs.rejected]: (state, action) => {
            state.jobsLoading = false;
            state.jobsError = action.error.message;
        },
        [getJobs.fulfilled]: (state, action) => {
            state.jobsLoading = false;
            state.jobs = action.payload;
        },
        [createJob.pending]: state => {
            state.jobsLoading = true;
            state.jobsError = "";
        },
        [createJob.rejected]: (state, action) => {
            state.jobsLoading = false;
            state.jobsError = action.error.message;
        },
        [createJob.fulfilled]: (state, action) => {
            state.jobsLoading = false;
            state.jobs = [...state.jobs, action.payload];
        },
        [updateJob.pending]: state => {
            state.jobsLoading = true;
            state.jobsError = "";
        },
        [updateJob.rejected]: (state, action) => {
            state.jobsLoading = false;
            state.jobsError = action.error.message;
        },
        [updateJob.fulfilled]: (state, action) => {
            state.jobsLoading = false;
            state.jobs = state.jobs.map(job =>
                job.id === action.payload.id ? action.payload : job
            );
        },
        [deleteJob.pending]: state => {
            state.jobsLoading = true;
            state.jobsError = "";
        },
        [deleteJob.rejected]: (state, action) => {
            state.jobsLoading = false;
            state.jobsError = action.error.message;
        },
        [deleteJob.fulfilled]: (state, action) => {
            state.jobsLoading = false;
            state.jobs = state.jobs.filter(job => job.id !== action.payload);
        },
        [startJobRun.pending]: state => {
            state.jobsLoading = true;
            state.jobsError = "";
        },
        [startJobRun.rejected]: (state, action) => {
            state.jobsLoading = false;
            state.jobsError = action.error.message;
        },
        [startJobRun.fulfilled]: (state, action) => {
            state.jobsLoading = false;
        },

    }
});

export const { resetState,setTags,setActiveTag,changeConfig,resetSuccess,addEntity,removeEntity,updateEntityLabels,clearTestResult} = requestSlice.actions;

const requestReducer = requestSlice.reducer;

export default configureStore({
    reducer: {
        request: requestReducer,
        anonymizer: anonymizerReducer,
    },
    middleware,
});



